import { translate } from '../i18n';

export enum locationConstant {
  ownerId = 1,
  goldCostOwnerId = 9,
  defaultLat = -17.010751 , 
  defaultLon = 145.425126,
}

export enum StaffConstant {
  DRIVER = 1,
  PILOT = 2,
  CREW = 3,
  DUTY_MANAGER = 6,
  PIC = 8,
  RES = 29,
}
export const currentDate = '2025-01-06T06:56:08.885Z';

export const latLon = {
  lat: -16.489526121856848,
  lon: 145.45970414513468,
};

export const truncateColumn = [
  'dropoff',
  'pickup',
  'comment',
  'agent',
  'name',
  'd1opschecklist',
];

export const highlights = ['allocated'];

export const viewBookingExcludedKeys = [
  'id',
  'date',
  'status',
  'name',
  'pretravel',
];

export enum allocation {
  LUGGAGE = "l'ge",
  PRETRAVEL = 'pretravel',
  EARLYRETURN = 'earlyReturn',
  ID = 'id',
  AGENT = 'agent',
  NAME = 'name',
  ALLOCATED = 'al',
  DATE = 'date',
  Fn = 'fn',
  DRIVERALLOCATED = 'allocated',
  STATUS = 'status',
}

export const setWithColumn = ['Ad', 'Ch', 'Inf', 'Trip'];

export enum HTTPErrorsCode {
  BAD_REQUEST = '400',
  UNAUTHORIZED = '401',
  NOT_FOUND = '404',
  REQUEST_TIMEOUT = '408',
  INTERNAL_SERVER_ERROR = '500',
  BAD_GATeWAY = '504',
}

export enum RateId {
  '1h' = 1,
  '24h' = 2,
  '1w' = 3,
}

export const defaultHiddenFlightColumns = ['id', 'comment'];
export const defaultHiddenPickupColumns = ['id', 'comment'];
export const defaultHiddenDropOffColumns = ['id', 'comment', 'pickup'];
export const defaultHiddenViewBookingColumns = [
  'person',
  'assocagent',
  'marketsource',
  'd1opschecklist',
];

export enum Theme {
  'light' = 'light',
  'dark' = 'dark',
}

export const flightHeaderToolTipColumns = ['Al', 'Fn'];

export const flightHeaderToolTip = {
  al: 'Allocated',
  fn: 'Flight',
};

export enum BookingStatus {
  CXL = 'cxl',
  CANCEL = 'cancel',
  PAID = 'paid',
  CONFIRMED = 'confirmed',
  REBOOk = 'rebook',
  HELDF = 'heldf',
  FTL = 'ftl',
  BOOKED = 'booked',
  CONFIRMATONREQUESTED = 'Confirmation Requested',
  TENTATIVE = 'Tentative',
  STANDBY = 'Standby',
  VOUCHER = 'Voucher/Prize',
  OUTSTANDING = 'Outstanding',
  ENQUIRY = 'Enquiry only no booking',
}

export const staffIdForComplianceTest = 587;

export enum COMPLIANCE_STATUS {
  onBoarding = 'Onboarding',
  expired = 'Expired',
  upcoming = 'Upcoming',
  current='Current',
  compliant='Compliant'
}

export enum CUSTOM_TOAST_ID {
  calender = 'calender',
  flight = 'flight',
  operation = 'operations',
  pickup = 'pickup',
}


export enum OPERATION_COMPLIANCE {
  statusExpired = 'Expired',
  statusUpComing = 'Upcoming',
  statusCurrent='Current'
}

